import { useTransactionStore } from '../state/useTransactionStore';
import { findRecurringTransactions } from '../utils/recurringTransactions';
import { formatCurrency, formatDate } from '../utils/formatters';

export function RecurringTransactions() {
  const { transactions } = useTransactionStore();
  const recurringTransactions = findRecurringTransactions(transactions);

  const subscriptions = recurringTransactions.filter(t => t.isSubscription);
  const otherRecurring = recurringTransactions.filter(t => !t.isSubscription);

  if (recurringTransactions.length === 0) {
    return (
      <div className="text-center py-12">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">No Recurring Transactions Found</h2>
        <p className="text-gray-600 dark:text-gray-400">
          Upload more transactions to detect recurring patterns and subscriptions.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {subscriptions.length > 0 && (
        <section>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-6">Subscriptions</h2>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {subscriptions.map((transaction) => (
              <div
                key={transaction.description}
                className="bg-white dark:bg-gray-800 rounded-lg shadow p-6"
              >
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
                  {transaction.description}
                </h3>
                <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
                  <p>Frequency: {transaction.frequency}</p>
                  <p>Average Amount: {formatCurrency(transaction.averageAmount)}</p>
                  <p>Confidence: {transaction.confidence}%</p>
                  <p>First Occurrence: {formatDate(new Date(transaction.firstDate))}</p>
                  <p>Last Occurrence: {formatDate(new Date(transaction.lastDate))}</p>
                  <p>Occurrences: {transaction.occurrences.length}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {otherRecurring.length > 0 && (
        <section>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-6">Other Recurring Transactions</h2>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {otherRecurring.map((transaction) => (
              <div
                key={transaction.description}
                className="bg-white dark:bg-gray-800 rounded-lg shadow p-6"
              >
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
                  {transaction.description}
                </h3>
                <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
                  <p>Frequency: {transaction.frequency}</p>
                  <p>Average Amount: {formatCurrency(transaction.averageAmount)}</p>
                  <p>First Occurrence: {formatDate(new Date(transaction.firstDate))}</p>
                  <p>Last Occurrence: {formatDate(new Date(transaction.lastDate))}</p>
                  <p>Occurrences: {transaction.occurrences.length}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
} 